/**
 * Atlas PM · 业务常量
 *
 * 任务形态、冻结规则、解冻窗口等——跨会话共用。
 */
/**
 * 任务形态（任务分类字段）。
 *
 * ⚠️ 设计说明：这是**一个可编辑字段**，用于筛选与星图聚类。
 *    底层由元数据引擎（field_definition）驱动——
 *    **新增形态不改表结构、不发版**，通过元数据引擎配置即可。
 *    这里的内置枚举只是"出厂预设"，不是封闭集合。
 */
export const TASK_FORM = {
    /** 现场勘察 */
    SITE_SURVEY: 'SITE_SURVEY',
    /** 方案设计 */
    SOLUTION_DESIGN: 'SOLUTION_DESIGN',
    /** 设备采购 */
    PROCUREMENT: 'PROCUREMENT',
    /** 施工实施 */
    CONSTRUCTION: 'CONSTRUCTION',
    /** 调试测试 */
    COMMISSIONING: 'COMMISSIONING',
    /** 验收交付 */
    ACCEPTANCE: 'ACCEPTANCE',
    /** 运维保障 */
    MAINTENANCE: 'MAINTENANCE',
    /** 文档编制 */
    DOCUMENTATION: 'DOCUMENTATION',
};
/** 任务形态的中文标签（前端展示用） */
export const TASK_FORM_LABELS = {
    SITE_SURVEY: '现场勘察',
    SOLUTION_DESIGN: '方案设计',
    PROCUREMENT: '设备采购',
    CONSTRUCTION: '施工实施',
    COMMISSIONING: '调试测试',
    ACCEPTANCE: '验收交付',
    MAINTENANCE: '运维保障',
    DOCUMENTATION: '文档编制',
};
/** 任务形态对应的星图配色（星座聚类用） */
export const TASK_FORM_COLORS = {
    SITE_SURVEY: '#5EE7FF',
    SOLUTION_DESIGN: '#A77BFF',
    PROCUREMENT: '#F0C060',
    CONSTRUCTION: '#54E0A8',
    COMMISSIONING: '#4FA8FF',
    ACCEPTANCE: '#FF6B8A',
    MAINTENANCE: '#7BD9C0',
    DOCUMENTATION: '#8FB2D0',
};
// ─────────────────────────────────────────────
// 冻结与解冻
// ─────────────────────────────────────────────
/** 解冻编辑窗口时长（小时）——超时自动回冻 */
export const UNLOCK_WINDOW_HOURS = 72;
/** 申请解冻时，理由的最小长度（强制填写实质性理由） */
export const UNLOCK_REASON_MIN_LENGTH = 20;
/** 自动回冻的巡检间隔（分钟） */
export const AUTO_REFREEZE_SCAN_INTERVAL_MINUTES = 10;
/** 冻结快照保留年限（对象存储 COMPLIANCE 保留期） */
export const FREEZE_RETENTION_YEARS = 10;
/**
 * 解冻是否已过期。
 *
 * ⭐ **数据库兜底的关键实现**：即使 Redis 挂了、定时任务没跑，
 *    查询时也必须调用本函数判断——不能只依赖队列。
 */
export function isUnlockExpired(unlockExpiresAt, now = new Date()) {
    if (!unlockExpiresAt)
        return true;
    return unlockExpiresAt.getTime() <= now.getTime();
}
/** 计算解冻到期时间 */
export function computeUnlockExpiry(from = new Date()) {
    return new Date(from.getTime() + UNLOCK_WINDOW_HOURS * 3600 * 1000);
}
// ─────────────────────────────────────────────
// 审批
// ─────────────────────────────────────────────
/** 审批模式 */
export const APPROVAL_MODE = {
    /** 正常审批 */
    NORMAL: 'NORMAL',
    /** 管理员代批（审批人离职/停用） */
    ADMIN_PROXY: 'ADMIN_PROXY',
};
/** 审批结论 */
export const APPROVAL_DECISION = {
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
};
/** 代批时理由的最小长度 */
export const PROXY_REASON_MIN_LENGTH = 20;
// ─────────────────────────────────────────────
// 操作日志
// ─────────────────────────────────────────────
/** 操作动作类型 */
export const AUDIT_ACTION = {
    TASK_CREATED: 'TASK_CREATED',
    TASK_UPDATED: 'TASK_UPDATED',
    TASK_SUBMITTED: 'TASK_SUBMITTED',
    TASK_FROZEN: 'TASK_FROZEN',
    TASK_REJECTED: 'TASK_REJECTED',
    TASK_UNLOCK_REQUESTED: 'TASK_UNLOCK_REQUESTED',
    TASK_UNLOCKED: 'TASK_UNLOCKED',
    TASK_AUTO_REFROZEN: 'TASK_AUTO_REFROZEN',
    TASK_ARCHIVED: 'TASK_ARCHIVED',
    FILE_UPLOADED: 'FILE_UPLOADED',
    FILE_LOCKED: 'FILE_LOCKED',
    FILE_MISSING_DETECTED: 'FILE_MISSING_DETECTED',
    FILE_TAMPERED_DETECTED: 'FILE_TAMPERED_DETECTED',
    USER_LOGIN: 'USER_LOGIN',
    USER_LOGOUT: 'USER_LOGOUT',
    PERMISSION_DENIED: 'PERMISSION_DENIED',
};
//# sourceMappingURL=constants.js.map